<template>
  <div class="bg-main bg-cover bg-center w-full h-screen">
    <h1 class="flex justify-center text-3xl font-bold pt-4">
      Yennenga och Måljakten
    </h1>
    <div class="mx-4 max-w-md md:mx-auto my-2">
      <div
        class="
          flex
          justify-center
          text-lg
          mt-4
          text-center
          px-4
          bg-white/70
          relative
          rounded-lg
        "
      >
        <p>
          Klicka på korten för att hitta de 17 globala målen. Om du klickar på
          en kung så vänds korten tillbaka. Kom ihåg var kungarna ligger och
          hjälp Yennenga att hitta alla mål!
        </p>
      </div>
    </div>
    <div class="flex justify-center px-10 relative max-w-md md:mx-auto">
      <div class="p-4 grid-cols-4 grid-rows-5 gap-2 grid absolute">
        <div class="wrapper" v-for="item in cards" :key="item.id">
          <button
            class="card"
            :class="{ flipme: item.isVisible }"
            @click="toggleItem(item.id)"
            :disabled="!isClickable || item.isVisible"
          >
            <div
              class="
                card__face
                rounded-md
                shadow-md
                overflow-hidden
                border border-gray-400
                card__face--back
              "
            >
              <img
                :src="require(`../assets/${item.img}`)"
                :alt="item.description"
              />
            </div>
            <div
              class="
                card__face
                border border-gray-400
                rounded-md
                shadow-md
                card__face--front
                bg-white
              "
            >
              <img
                class="pt-1 pl-2"
                src="../assets/horse.png"
                alt="Ouagadougou"
                draggable="false"
              />
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import fail from "../assets/sound/fail.mp3";

const goalAssets = [
  {
    img: "01-ingen-fattigdom.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "02-ingen-hunger.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "03-god-halsa-och-valbefinnande.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "04_god_utbildning.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "05-jamstalldhet.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "06-rent-vatten-och-sanitet-for-alla.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "07-hallbar-energi-for-alla.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "08-anstandiga-arbetsvillkor-och-ekonomisk-tillvaxt.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "09-hallbar-industri-innovationer-och-infrastruktur.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "10-minskad-ojamnlikhet.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "11-hallbara-stader-och-samhallen.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "12-hallbar-konsumtion-och-produktion.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "13-bekampa-klimatforandringarna.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "14_hav_och_marina_resurser.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "15_ekosystem.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "16_fredliga_samhallen.png",
    description: "Ingen ska vara fattig!",
  },
  {
    img: "17_genomforande_och_partnerskap.png",
    description: "Ingen ska vara fattig!",
  },
];

export default {
  name: "Game",
  data() {
    return {
      cards: [],
      isClickable: true,
      failSound: null,
    };
  },
  created() {
    this.failSound = new Audio(fail);
    this.cards = this.createGoals();
    this.cards.push(...this.createKings(3));
    this.shuffle();
  },
  computed: {},
  methods: {
    playFailSound() {
      this.failSound.play();
    },
    createGoals() {
      return goalAssets.map(({ img, description }, index) => {
        return { id: index, img, description, isVisible: false, isKing: false };
      });
    },
    createKings(numberOfKings) {
      const kings = [];

      for (let i = 1; i <= numberOfKings; i++) {
        kings.push({
          id: `king-${i}`,
          img: "king.jpg",
          description: "A mad king",
          isVisible: false,
          isKing: true,
        });
      }

      return kings;
    },
    shuffle() {
      let currentIndex = this.cards.length,
        randomIndex;
      // While there remain elements to shuffle.
      while (currentIndex != 0) {
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [this.cards[currentIndex], this.cards[randomIndex]] = [
          this.cards[randomIndex],
          this.cards[currentIndex],
        ];
      }
    },
    toggleItem(id) {
      const item = this.cards.find((card) => card.id === id);
      item.isVisible = !item.isVisible;

      if (item.isKing) {
        this.isClickable = false;

        setTimeout(() => {
          this.resetBoard();
          this.isClickable = true;
        }, 1500);

        this.playFailSound();
      } else if (this.hasWon()) {
        setTimeout(() => {
          this.$router.push("/klar");
        }, 1000);
      }
    },
    hasWon() {
      const undiscoveredGoal = this.cards.find(
        (card) => card.isKing === false && card.isVisible === false
      );

      if (!undiscoveredGoal) {
        return true;
      }

      return false;
    },
    resetBoard() {
      this.cards.forEach((card) => (card.isVisible = false));
    },
  },
};
</script>
